import React, { useEffect, useRef, useState } from "react";
import { Send } from "lucide-react";
import api from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

const C = {
  fr: { title: "Messagerie", subtitle: "Échangez directement avec votre conseiller.",
    empty: "Aucun message pour le moment. Écrivez à votre conseiller ci-dessous.", advisor: "Conseiller",
    placeholder: "Votre message…", send: "Envoyer" },
  en: { title: "Messages", subtitle: "Chat directly with your advisor.",
    empty: "No message yet. Write to your advisor below.", advisor: "Advisor",
    placeholder: "Your message…", send: "Send" },
};

export default function Messagerie() {
  const { lang } = useLang();
  const c = C[lang];
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState("");
  const [sending, setSending] = useState(false);
  const endRef = useRef(null);

  const load = () => api.get("/messages/me").then((r) => setMessages(r.data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 8000); return () => clearInterval(t); }, []);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages]);

  const send = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setSending(true);
    try {
      const { data } = await api.post("/messages", { text: text.trim() });
      setMessages((m) => [...m, data]); setText("");
    } catch (err) { console.error("Message send failed", err); } finally { setSending(false); }
  };

  return (
    <div data-testid="messagerie-page">
      <h1 className="font-heading text-3xl sm:text-4xl text-navy">{c.title}</h1>
      <p className="text-muted-foreground mt-2">{c.subtitle}</p>

      <div className="mt-8 bg-white border border-border flex flex-col h-[60vh]">
        <div className="flex-1 overflow-y-auto p-5 space-y-4" data-testid="messages-list">
          {messages.length === 0 && (
            <p className="text-center text-sm text-muted-foreground mt-10">{c.empty}</p>
          )}
          {messages.map((m) => {
            const mine = m.sender === "client";
            return (
              <div key={m.id} className={`flex ${mine ? "justify-end" : "justify-start"}`}>
                <div className={`max-w-[75%] px-4 py-2.5 text-sm ${mine ? "bg-navy text-white" : "bg-[#F3F4F6] text-navy border border-border"}`}>
                  {!mine && <div className="text-[10px] uppercase tracking-widest text-gold font-semibold mb-1">{c.advisor}</div>}
                  <p className="leading-relaxed whitespace-pre-wrap">{m.text}</p>
                  <div className={`text-[10px] mt-1 ${mine ? "text-white/50" : "text-muted-foreground"}`}>{new Date(m.created_at).toLocaleString(lang === "fr" ? "fr-FR" : "en-GB", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })}</div>
                </div>
              </div>
            );
          })}
          <div ref={endRef} />
        </div>
        <form onSubmit={send} className="border-t border-border p-3 flex gap-2">
          <input data-testid="message-input" value={text} onChange={(e) => setText(e.target.value)} placeholder={c.placeholder}
            className="flex-1 border border-border px-4 py-3 text-sm focus:outline-none focus:border-gold" />
          <button data-testid="message-send" disabled={sending} className="bg-gold hover:bg-gold-hover text-white px-5 flex items-center gap-2 transition-colors disabled:opacity-60">
            <Send size={16} /> <span className="hidden sm:inline">{c.send}</span>
          </button>
        </form>
      </div>
    </div>
  );
}
